"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PuzzlePieces = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _framerMotion = require("framer-motion");

var _theming = require("@storybook/theming");

var _excluded = ["path"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var colors = ['#FC521F', '#CA90FF', '#1EA7FD', '#FFAE00', '#37D5D3', '#FC521F', '#66BF3C'];

function pickRandom(array) {
  return array[Math.floor(Math.random() * array.length)];
}

var shapes = [{
  x: 250.8459930419922,
  y: 124.8280029296875,
  path: 'M267.669 158.368C258.378 158.368 250.846 150.86 250.846 141.598C250.846 132.336 258.378 124.828 267.669 124.828C276.959 124.828 284.491 132.336 284.491 141.598C284.491 150.86 276.959 158.368 267.669 158.368Z'
}, {
  x: 261.0530090332031,
  y: 135.0030059814453,
  path: 'M267.669 148.193C271.322 148.193 274.284 145.24 274.284 141.598C274.284 137.956 271.322 135.003 267.669 135.003C264.015 135.003 261.053 137.956 261.053 141.598C261.053 145.24 264.015 148.193 267.669 148.193Z'
}, {
  x: 308.98199462890625,
  y: 399.0899963378906,
  path: 'M330.611 442.213C318.666 442.213 308.982 432.559 308.982 420.651C308.982 408.743 318.666 399.09 330.611 399.09C342.556 399.09 352.24 408.743 352.24 420.651C352.24 432.559 342.556 442.213 330.611 442.213Z'
}, {
  x: 322.1050109863281,
  y: 412.1719970703125,
  path: 'M330.611 429.13C335.309 429.13 339.117 425.334 339.117 420.651C339.117 415.968 335.309 412.172 330.611 412.172C325.914 412.172 322.105 415.968 322.105 420.651C322.105 425.334 325.914 429.13 330.611 429.13Z'
}, {
  x: 371.0820007324219,
  y: 71.10990142822266,
  path: 'M390.908 110.639C379.958 110.639 371.082 101.79 371.082 90.8744C371.082 79.9588 379.958 71.1099 390.908 71.1099C401.858 71.1099 410.734 79.9588 410.734 90.8744C410.734 101.79 401.858 110.639 390.908 110.639Z'
}, {
  x: 383.1109924316406,
  y: 83.10209655761719,
  path: 'M390.908 98.6472C395.214 98.6472 398.705 95.1673 398.705 90.8746C398.705 86.582 395.214 83.1021 390.908 83.1021C386.602 83.1021 383.111 86.582 383.111 90.8746C383.111 95.1673 386.602 98.6472 390.908 98.6472Z'
}, {
  x: 90.93550109863281,
  y: 75.87699890136719,
  path: 'M103.552 101.032C96.5843 101.032 90.9355 95.4007 90.9355 88.4544C90.9355 81.5081 96.5843 75.877 103.552 75.877C110.52 75.877 116.169 81.5081 116.169 88.4544C116.169 95.4007 110.52 101.032 103.552 101.032Z'
}, {
  x: 98.5907974243164,
  y: 83.50830078125,
  path: 'M103.552 93.4007C106.293 93.4007 108.514 91.1862 108.514 88.4545C108.514 85.7228 106.293 83.5083 103.552 83.5083C100.812 83.5083 98.5908 85.7228 98.5908 88.4545C98.5908 91.1862 100.812 93.4007 103.552 93.4007Z'
}, {
  x: 188.0500030517578,
  y: 12.29539966583252,
  path: 'M204.872 45.8353C195.581 45.8353 188.05 38.3271 188.05 29.0653C188.05 19.8036 195.581 12.2954 204.872 12.2954C214.163 12.2954 221.695 19.8036 221.695 29.0653C221.695 38.3271 214.163 45.8353 204.872 45.8353Z'
}, {
  x: 198.25599670410156,
  y: 22.470199584960938,
  path: 'M204.872 35.66C208.526 35.66 211.487 32.7074 211.487 29.0651C211.487 25.4229 208.526 22.4702 204.872 22.4702C201.218 22.4702 198.256 25.4229 198.256 29.0651C198.256 32.7074 201.218 35.66 204.872 35.66Z'
}, {
  x: 38.6078987121582,
  y: 191.98800659179688,
  path: 'M62.0391 238.704C49.0984 238.704 38.6079 228.247 38.6079 215.346C38.6079 202.446 49.0984 191.988 62.0391 191.988C74.9797 191.988 85.4702 202.446 85.4702 215.346C85.4702 228.247 74.9797 238.704 62.0391 238.704Z'
}, {
  x: 52.825199127197266,
  y: 206.16000366210938,
  path: 'M62.0397 224.532C67.1287 224.532 71.2542 220.419 71.2542 215.346C71.2542 210.273 67.1287 206.16 62.0397 206.16C56.9507 206.16 52.8252 210.273 52.8252 215.346C52.8252 220.419 56.9507 224.532 62.0397 224.532Z'
}, {
  x: 131.13099670410156,
  y: 159.63900756835938,
  path: 'M154.563 206.355C141.622 206.355 131.131 195.897 131.131 182.997C131.131 170.096 141.622 159.639 154.563 159.639C167.503 159.639 177.994 170.096 177.994 182.997C177.994 195.897 167.503 206.355 154.563 206.355Z'
}, {
  x: 145.34800720214844,
  y: 173.81100463867188,
  path: 'M154.562 192.182C159.651 192.182 163.777 188.069 163.777 182.996C163.777 177.923 159.651 173.811 154.562 173.811C149.473 173.811 145.348 177.923 145.348 182.996C145.348 188.069 149.473 192.182 154.562 192.182Z'
}, {
  x: 89.52100372314453,
  y: 248.56100463867188,
  path: 'M116.557 302.464C101.625 302.464 89.521 290.398 89.521 275.513C89.521 260.628 101.625 248.561 116.557 248.561C131.488 248.561 143.593 260.628 143.593 275.513C143.593 290.398 131.488 302.464 116.557 302.464Z'
}, {
  x: 299.8819885253906,
  y: 327.8949890136719,
  path: 'M326.918 381.798C311.986 381.798 299.882 369.731 299.882 354.846C299.882 339.961 311.986 327.895 326.918 327.895C341.849 327.895 353.954 339.961 353.954 354.846C353.954 369.731 341.849 381.798 326.918 381.798Z'
}, {
  x: 55.16059875488281,
  y: 153.5279998779297,
  path: 'M98.3889 153.528L126.711 181.762L112.177 196.25L98.0162 182.133L83.4826 196.622L55.1606 168.388L69.6943 153.9L83.8552 168.017L98.3889 153.528Z'
}, {
  x: 360.32000732421875,
  y: 315.86700439453125,
  path: 'M403.549 315.867L431.87 344.1L417.337 358.589L403.176 344.472L388.642 358.96L360.32 330.727L374.854 316.238L389.015 330.355L403.549 315.867Z'
}, {
  x: 374.43798828125,
  y: 158.3679962158203,
  path: 'M379.243 171.943L402.831 158.368L409.819 170.434L398.025 177.222L405.013 189.288L381.426 202.864L374.438 190.797L386.232 184.01L379.243 171.943Z'
}, {
  x: 0,
  y: 189.5760040283203,
  path: 'M4.80539 203.151L28.3926 189.576L35.3809 201.642L23.5873 208.43L30.5755 220.496L6.98824 234.072L0 222.005L11.7936 215.218L4.80539 203.151Z'
}, {
  x: 87.44139862060547,
  y: 218.23599243164062,
  path: 'M89.8441 225.024L101.638 218.236L105.132 224.269L99.235 227.663L102.729 233.696L90.9355 240.484L87.4414 234.451L93.3382 231.057L89.8441 225.024Z'
}, {
  x: 206.50799560546875,
  y: 296.4209899902344,
  path: 'M208.911 303.209L220.704 296.421L224.198 302.454L218.301 305.848L221.796 311.881L210.002 318.669L206.508 312.636L212.405 309.242L208.911 303.209Z'
}, {
  x: 341.2720031738281,
  y: 373.0769958496094,
  path: 'M343.675 379.865L355.468 373.077L358.962 379.11L353.066 382.504L356.56 388.537L344.766 395.325L341.272 389.292L347.169 385.898L343.675 379.865Z'
}, {
  x: 197.66299438476562,
  y: 422.77899169921875,
  path: 'M200.066 429.567L211.859 422.779L215.354 428.812L209.457 432.206L212.951 438.239L201.157 445.027L197.663 438.994L203.56 435.6L200.066 429.567Z'
}, {
  x: 57.9541015625,
  y: 71.61669921875,
  path: 'M60.3568 78.4045L72.1504 71.6167L75.6445 77.6498L69.7477 81.0437L73.2419 87.0769L61.4482 93.8647L57.9541 87.8316L63.8509 84.4377L60.3568 78.4045Z'
}, {
  x: 232.71600341796875,
  y: 55.32569885253906,
  path: 'M271.071 94.0421L242.854 113.738L232.716 99.3035L246.824 89.4557L236.685 75.0214L264.902 55.3257L275.04 69.76L260.932 79.6078L271.071 94.0421Z'
}, {
  x: 151.50100708007812,
  y: 30.44969940185547,
  path: 'M190.106 42.4732L199.021 75.6416L181.948 80.2022L177.49 63.6181L160.416 68.1787L151.501 35.0104L168.575 30.4497L173.032 47.0339L190.106 42.4732Z'
}, {
  x: 138.8990020751953,
  y: 116.51499938964844,
  path: 'M156.525 134.631L190.55 135.816L189.936 153.34L138.899 151.564L140.127 116.515L157.139 117.107L156.525 134.631V134.631Z'
}, {
  x: 234.4759979248047,
  y: 312.2699890136719,
  path: 'M252.102 330.386L286.126 331.571L285.512 349.095L234.476 347.319L235.703 312.27L252.716 312.862L252.102 330.386Z'
}, {
  x: 277.55499267578125,
  y: 22.955101013183594,
  path: 'M295.181 41.0718L329.205 42.2563L328.591 59.7808L277.555 58.0041L278.782 22.9551L295.795 23.5473L295.181 41.0718Z'
}, {
  x: 140.1269989013672,
  y: 411.6409912109375,
  path: 'M157.753 429.757L191.778 430.942L191.164 448.466L140.127 446.69L141.355 411.641L158.367 412.233L157.753 429.757Z'
}, {
  x: 275.1990051269531,
  y: 265.5270080566406,
  path: 'M292.825 283.644L326.85 284.829L326.236 302.353L275.199 300.576L276.427 265.527L293.439 266.12L292.825 283.644V283.644Z'
}, {
  x: 272.8840026855469,
  y: 78.1156997680664,
  path: 'M296.172 94.0492L326.232 78.1157L334.49 93.5984L289.4 117.499L272.884 86.5332L287.914 78.5665L296.172 94.0492Z'
}, {
  x: 181.7259979248047,
  y: 163.33900451660156,
  path: 'M191.041 169.713L203.065 163.339L206.369 169.532L188.332 179.093L181.726 166.706L187.738 163.52L191.041 169.713Z'
}, {
  x: 219.33900451660156,
  y: 0,
  path: 'M232.924 7.94399L219.339 6.997L219.83 0L240.207 1.42048L239.225 15.4145L232.433 14.941L232.924 7.94399V7.94399Z'
}, {
  x: 285.08099365234375,
  y: 314.1419982910156,
  path: 'M294.396 320.515L306.42 314.142L309.724 320.335L291.687 329.895L285.081 317.509L291.093 314.322L294.396 320.515Z'
}, {
  x: 112.27100372314453,
  y: 346.8760070800781,
  path: 'M119.254 361.206L117.594 347.731L124.578 346.876L127.067 367.088L113.1 368.798L112.271 362.061L119.254 361.206Z'
}, {
  x: 113.09500122070312,
  y: 418.36700439453125,
  path: 'M122.41 424.741L134.434 418.367L137.737 424.56L119.701 434.12L113.095 421.734L119.107 418.547L122.41 424.741V424.741Z'
}, {
  x: 327.4639892578125,
  y: 61.56050109863281,
  path: 'M337.217 71.2498L345.787 81.8001L340.319 86.2142L327.464 70.3888L338.4 61.5605L342.685 66.8357L337.217 71.2498V71.2498Z'
}, {
  x: 417.9440002441406,
  y: 220.67999267578125,
  path: 'M417.944 245.555L460 220.68V270.43L417.944 245.555Z'
}, {
  x: 170.52200317382812,
  y: 177.93699645996094,
  path: 'M170.522 210.355L207.044 177.937L216.567 226.773L170.522 210.355Z'
}, {
  x: 4.612299919128418,
  y: 140.50100708007812,
  path: 'M4.6123 184.613L17.5669 140.501L49.658 174.807L4.6123 184.613Z'
}, {
  x: 162.7830047607422,
  y: 79.67970275878906,
  path: 'M162.783 128.416L163.908 79.6797L206.231 106.044L162.783 128.416Z'
}, {
  x: 361.10400390625,
  y: 364.47198486328125,
  path: 'M361.104 413.208L362.228 364.472L404.551 390.836L361.104 413.208Z'
}, {
  x: 100.30000305175781,
  y: 373.0769958496094,
  path: 'M100.3 421.813L101.425 373.077L143.748 399.441L100.3 421.813Z'
}, {
  x: 241.8350067138672,
  y: 19.980499267578125,
  path: 'M241.835 58.9694L242.735 19.9805L276.593 41.0716L241.835 58.9694Z'
}, {
  x: 213.98899841308594,
  y: 103.1709976196289,
  path: 'M213.989 110.731L226.77 103.171V118.291L213.989 110.731Z'
}, {
  x: 258.3680114746094,
  y: 281.27801513671875,
  path: 'M258.368 288.838L271.149 281.278V296.398L258.368 288.838Z'
}, {
  x: 259.5929870605469,
  y: 4.976069927215576,
  path: 'M259.593 12.5359L272.374 4.97607V20.0957L259.593 12.5359Z'
}, {
  x: 117.66300201416016,
  y: 149.58599853515625,
  path: 'M117.663 157.146L130.444 149.586V164.706L117.663 157.146Z'
}, {
  x: 214.91099548339844,
  y: 320.3340148925781,
  path: 'M214.911 327.894L227.692 320.334V335.454L214.911 327.894Z'
}, {
  x: 315.57501220703125,
  y: 103.50700378417969,
  path: 'M315.575 114.168L333.599 103.507V124.829L315.575 114.168Z'
}, {
  x: 348.5769958496094,
  y: 67.42870330810547,
  path: 'M348.577 78.0896L366.601 67.4287V88.7505L348.577 78.0896Z'
}, {
  x: 340.80999755859375,
  y: 132.61000061035156,
  path: 'M340.81 152.51L374.455 132.61V172.41L340.81 152.51Z'
}, {
  x: 300.7229919433594,
  y: 223.78599548339844,
  path: 'M300.723 244.662L301.571 223.786L319.509 235.399L300.723 244.662Z'
}, {
  x: 369.64801025390625,
  y: 209.93899536132812,
  path: 'M382.265 235.094C375.297 235.094 369.648 229.463 369.648 222.517C369.648 215.571 375.297 209.939 382.265 209.939C389.233 209.939 394.882 215.571 394.882 222.517C394.882 229.463 389.233 235.094 382.265 235.094Z'
}, {
  x: 245.55599975585938,
  y: 218.34100341796875,
  path: 'M255.77 238.704C250.129 238.704 245.556 234.146 245.556 228.523C245.556 222.899 250.129 218.341 255.77 218.341C261.411 218.341 265.983 222.899 265.983 228.523C265.983 234.146 261.411 238.704 255.77 238.704Z'
}, {
  x: 257.18798828125,
  y: 304.13299560546875,
  path: 'M267.401 324.496C261.76 324.496 257.188 319.938 257.188 314.315C257.188 308.691 261.76 304.133 267.401 304.133C273.042 304.133 277.615 308.691 277.615 314.315C277.615 319.938 273.042 324.496 267.401 324.496Z'
}, {
  x: 382.15301513671875,
  y: 295.7969970703125,
  path: 'M392.367 316.16C386.726 316.16 382.153 311.602 382.153 305.979C382.153 300.355 386.726 295.797 392.367 295.797C398.008 295.797 402.58 300.355 402.58 305.979C402.58 311.602 398.008 316.16 392.367 316.16Z'
}, {
  x: 288.3900146484375,
  y: 62.63330078125,
  path: 'M297.402 80.6011C292.425 80.6011 288.39 76.5789 288.39 71.6172C288.39 66.6555 292.425 62.6333 297.402 62.6333C302.379 62.6333 306.414 66.6555 306.414 71.6172C306.414 76.5789 302.379 80.6011 297.402 80.6011Z'
}, {
  x: 426.9219970703125,
  y: 138.67799377441406,
  path: 'M435.934 156.646C430.957 156.646 426.922 152.624 426.922 147.662C426.922 142.7 430.957 138.678 435.934 138.678C440.912 138.678 444.946 142.7 444.946 147.662C444.946 152.624 440.912 156.646 435.934 156.646Z'
}, {
  x: 195.21400451660156,
  y: 117.4990005493164,
  path: 'M203.626 134.269C198.98 134.269 195.214 130.515 195.214 125.884C195.214 121.253 198.98 117.499 203.626 117.499C208.271 117.499 212.037 121.253 212.037 125.884C212.037 130.515 208.271 134.269 203.626 134.269Z'
}, {
  x: 152.54800415039062,
  y: 10.505900382995605,
  path: 'M160.959 27.2758C156.314 27.2758 152.548 23.5217 152.548 18.8908C152.548 14.2599 156.314 10.5059 160.959 10.5059C165.604 10.5059 169.37 14.2599 169.37 18.8908C169.37 23.5217 165.604 27.2758 160.959 27.2758Z'
}, {
  x: 64.53710174560547,
  y: 369.77301025390625,
  path: 'M72.9483 386.543C68.3029 386.543 64.5371 382.789 64.5371 378.158C64.5371 373.527 68.3029 369.773 72.9483 369.773C77.5937 369.773 81.3595 373.527 81.3595 378.158C81.3595 382.789 77.5937 386.543 72.9483 386.543Z'
}, {
  x: 300.1099853515625,
  y: 15.414600372314453,
  path: 'M308.521 32.1845C303.876 32.1845 300.11 28.4304 300.11 23.7995C300.11 19.1686 303.876 15.4146 308.521 15.4146C313.166 15.4146 316.932 19.1686 316.932 23.7995C316.932 28.4304 313.166 32.1845 308.521 32.1845Z'
}, {
  x: 68.7426986694336,
  y: 240.55599975585938,
  path: 'M75.0511 253.134C71.567 253.134 68.7427 250.318 68.7427 246.845C68.7427 243.372 71.567 240.556 75.0511 240.556C78.5351 240.556 81.3595 243.372 81.3595 246.845C81.3595 250.318 78.5351 253.134 75.0511 253.134Z'
}, {
  x: 25.231000900268555,
  y: 126.62100219726562,
  path: 'M31.5393 139.199C28.0553 139.199 25.231 136.383 25.231 132.91C25.231 129.437 28.0553 126.621 31.5393 126.621C35.0234 126.621 37.8477 129.437 37.8477 132.91C37.8477 136.383 35.0234 139.199 31.5393 139.199Z'
}, {
  x: 215.81300354003906,
  y: 412.17498779296875,
  path: 'M222.121 424.752C218.637 424.752 215.813 421.937 215.813 418.464C215.813 414.99 218.637 412.175 222.121 412.175C225.605 412.175 228.43 414.99 228.43 418.464C228.43 421.937 225.605 424.752 222.121 424.752Z'
}, {
  x: 184.85499572753906,
  y: 257.92498779296875,
  path: 'M191.164 270.502C187.68 270.502 184.855 267.687 184.855 264.214C184.855 260.74 187.68 257.925 191.164 257.925C194.648 257.925 197.472 260.74 197.472 264.214C197.472 267.687 194.648 270.502 191.164 270.502Z'
}, {
  x: 229.62600708007812,
  y: 353.1159973144531,
  path: 'M235.935 365.693C232.451 365.693 229.626 362.878 229.626 359.404C229.626 355.931 232.451 353.116 235.935 353.116C239.419 353.116 242.243 355.931 242.243 359.404C242.243 362.878 239.419 365.693 235.935 365.693Z'
}, {
  x: 424.09698486328125,
  y: 257.92498779296875,
  path: 'M430.406 270.502C426.922 270.502 424.097 267.687 424.097 264.214C424.097 260.74 426.922 257.925 430.406 257.925C433.89 257.925 436.714 260.74 436.714 264.214C436.714 267.687 433.89 270.502 430.406 270.502Z'
}, {
  x: 306.41400146484375,
  y: 240.48399353027344,
  path: 'M366.494 270.431H306.414C306.414 253.892 319.863 240.484 336.454 240.484C353.045 240.484 366.494 253.892 366.494 270.431Z'
}, {
  x: 212.03700256347656,
  y: 430.0539855957031,
  path: 'M272.117 460H212.037C212.037 443.461 225.486 430.054 242.077 430.054C258.667 430.054 272.117 443.461 272.117 460Z'
}, {
  x: 45.91210174560547,
  y: 334.5249938964844,
  path: 'M105.992 364.471H45.9121C45.9121 347.932 59.3615 334.525 75.9521 334.525C92.5427 334.525 105.992 347.932 105.992 364.471Z'
}, {
  x: 83.03119659423828,
  y: 23.799299240112305,
  path: 'M83.0312 53.7456L135.062 23.7993C143.357 38.1224 138.434 56.4373 124.067 64.7067C109.699 72.9762 91.3266 68.0687 83.0312 53.7456Z'
}, {
  x: 168.52000427246094,
  y: 372.3680114746094,
  path: 'M191.951 372.368V419.084C179.01 419.084 168.52 408.626 168.52 395.726C168.52 382.825 179.01 372.368 191.951 372.368Z'
}, {
  x: 392.12799072265625,
  y: 182.8179931640625,
  path: 'M392.128 203.794L427.147 182.818L448.188 217.728C428.848 229.313 403.749 223.074 392.128 203.794Z'
}, {
  x: 306.41400146484375,
  y: 183.66099548339844,
  path: 'M306.414 197.448L319.769 183.661L333.599 196.975C326.223 204.589 314.052 204.801 306.414 197.448Z'
}, {
  x: 172.1199951171875,
  y: 4.556640148162842,
  path: 'M172.12 14.8966L182.136 4.55664L192.508 14.5418C186.976 20.2524 177.848 20.4112 172.12 14.8966Z'
}, {
  x: 412.4049987792969,
  y: 156.156005859375,
  path: 'M412.405 169.942L425.76 156.156L439.59 169.469C432.214 177.083 420.043 177.295 412.405 169.942Z'
}, {
  x: 164.39300537109375,
  y: 320.3340148925781,
  path: 'M164.393 349.631L192.773 320.334L222.161 348.625C206.487 364.805 180.624 365.255 164.393 349.631Z'
}, {
  x: 411.5660095214844,
  y: 274.156005859375,
  path: 'M431.372 329.521L411.566 293.901L447.298 274.156C458.237 293.828 451.107 318.616 431.372 329.521Z'
}, {
  x: 92.27980041503906,
  y: 197.5240020751953,
  path: 'M92.2798 199.422L107.784 197.524L109.688 212.98C101.125 214.028 93.3312 207.958 92.2798 199.422Z'
}, {
  x: 4.387700080871582,
  y: 278.5880126953125,
  path: 'M4.3877 280.267L18.1031 278.588L19.7871 292.26C12.2123 293.188 5.31776 287.818 4.3877 280.267Z'
}, {
  x: 159.93099975585938,
  y: 267.8529968261719,
  path: 'M159.931 269.751L175.435 267.853L177.339 283.309C168.776 284.357 160.982 278.287 159.931 269.751Z'
}, {
  x: 136.81300354003906,
  y: 375.7860107421875,
  path: 'M136.813 378.414L158.281 375.786L160.916 397.187C149.06 398.638 138.269 390.233 136.813 378.414Z'
}, {
  x: 338.5899963378906,
  y: 87.6323013305664,
  path: 'M370.653 127.564L338.59 119.595L346.584 87.6323C364.292 92.0335 375.068 109.912 370.653 127.564Z'
}, {
  x: 192.88699340820312,
  y: 228.9219970703125,
  path: 'M192.887 230.82L208.391 228.922L210.295 244.378C201.732 245.426 193.938 239.356 192.887 230.82Z'
}, {
  x: 257.9670104980469,
  y: 418.447998046875,
  path: 'M257.967 420.346L273.472 418.448L275.375 433.904C266.812 434.952 259.019 428.882 257.967 420.346Z'
}, {
  x: 4.963379859924316,
  y: 236.96200561523438,
  path: 'M4.96338 270.502V236.962H38.6081V270.502H4.96338Z'
}, {
  x: 128.45399475097656,
  y: 75.00489807128906,
  path: 'M143.748 105.497L128.454 90.251L143.748 75.0049L159.042 90.251L143.748 105.497Z'
}, {
  x: 319.5090026855469,
  y: 201.76600646972656,
  path: 'M326.004 238.704L319.509 208.241L350.068 201.766L356.563 232.229L326.004 238.704Z'
}, {
  x: 361.08599853515625,
  y: 235.093994140625,
  path: 'M361.086 245.875V235.094H371.901V245.875H361.086Z'
}, {
  x: 373.8110046386719,
  y: 56.13959884643555,
  path: 'M373.811 66.9203V56.1396H384.625V66.9203H373.811Z'
}, {
  x: 263.3909912109375,
  y: 105.49099731445312,
  path: 'M274.318 122.672L263.391 116.384L269.7 105.491L280.626 111.78L274.318 122.672Z'
}, {
  x: 76.4365005493164,
  y: 142.447998046875,
  path: 'M87.363 159.629L76.4365 153.34L82.7449 142.448L93.6714 148.736L87.363 159.629Z'
}, {
  x: 135.31300354003906,
  y: 52.97019958496094,
  path: 'M146.239 70.1513L135.313 63.8626L141.621 52.9702L152.548 59.2589L146.239 70.1513Z'
}, {
  x: 220.6269989013672,
  y: 221.3300018310547,
  path: 'M236.927 233.072L225.148 237.579L220.627 225.837L232.406 221.33L236.927 233.072Z'
}, {
  x: 37.84769821166992,
  y: 177.1820068359375,
  path: 'M54.1479 188.924L42.3691 193.432L37.8477 181.689L49.6264 177.182L54.1479 188.924Z'
}, {
  x: 50.63869857788086,
  y: 288.8380126953125,
  path: 'M66.9389 300.58L55.1601 305.088L50.6387 293.346L62.4174 288.838L66.9389 300.58Z'
}, {
  x: 392.8529968261719,
  y: 361.06201171875,
  path: 'M407.422 383.97L392.853 375.585L401.264 361.062L415.833 369.446L407.422 383.97Z'
}, {
  x: 439.5710144042969,
  y: 177.3730010986328,
  path: 'M450.498 194.554L439.571 188.265L445.88 177.373L456.806 183.661L450.498 194.554Z'
}, {
  x: 361.1409912109375,
  y: 347.78399658203125,
  path: 'M372.068 364.965L361.141 358.677L367.45 347.784L378.376 354.073L372.068 364.965Z'
}, {
  x: 278.3030090332031,
  y: 367.1260070800781,
  path: 'M289.229 384.308L278.303 378.019L284.611 367.126L295.538 373.415L289.229 384.308Z'
}, {
  x: 201.0050048828125,
  y: 49.6416015625,
  path: 'M218.848 58.5352L209.926 67.4288L201.005 58.5352L209.926 49.6416L218.848 58.5352Z'
}, {
  x: 266.6709899902344,
  y: 178.49600219726562,
  path: 'M283.285 178.496L303.687 182.819L287.074 260.735L266.671 256.412L283.285 178.496Z'
}, {
  x: 66.09770202636719,
  y: 275.0320129394531,
  path: 'M79.9039 275.032L91.1461 327.757L77.3398 330.683L66.0977 277.957L79.9039 275.032Z'
}, {
  x: 132.9929962158203,
  y: 283.4540100097656,
  path: 'M149.606 283.454L170.009 287.777L153.395 365.693L132.993 361.37L149.606 283.454Z'
}, {
  x: 199.41600036621094,
  y: 363.9209899902344,
  path: 'M208.16 363.921L218.898 366.196L210.154 407.205L199.416 404.93L208.16 363.921Z'
}, {
  x: 224.52200317382812,
  y: 22.63129997253418,
  path: 'M227.456 22.6313L238.407 23.3948L235.473 65.2174L224.522 64.454L227.456 22.6313Z'
}, {
  x: 278.3030090332031,
  y: 385.1419982910156,
  path: 'M319.841 385.142L321.558 395.951L280.02 402.509L278.303 391.7L319.841 385.142Z'
}, {
  x: 323.031005859375,
  y: 21.31839942932129,
  path: 'M371.942 48.3928L364.853 59.2757L323.031 32.2012L330.121 21.3184L371.942 48.3928Z'
}, {
  x: 199.02099609375,
  y: 115.83999633789062,
  path: 'M234.063 138.988L245.462 150.351L233.64 162.136L222.242 150.772L210.42 162.557L199.021 151.193L234.485 115.84L245.884 127.204L234.063 138.988Z'
}, {
  x: 325.8380126953125,
  y: 271.16900634765625,
  path: 'M360.88 294.317L372.279 305.681L360.457 317.465L349.058 306.101L337.237 317.886L325.838 306.522L361.302 271.169L372.701 282.533L360.88 294.317Z'
}, {
  x: 146.54299926757812,
  y: 212.8280029296875,
  path: 'M172.207 233.644L187.539 238.61L182.373 254.46L167.041 249.494L161.875 265.344L146.543 260.378L162.042 212.828L177.373 217.794L172.207 233.644Z'
}, {
  x: 97.67289733886719,
  y: 104.4000015258789,
  path: 'M120.849 122.845L134.055 127.636L129.07 141.289L115.864 136.497L110.879 150.15L97.6729 145.358L112.627 104.4L125.833 109.192L120.849 122.845Z'
}, {
  x: 371.0820007324219,
  y: 223.78599548339844,
  path: 'M406.123 246.934L417.522 258.297L405.701 270.081L394.302 258.718L382.48 270.502L371.082 259.139L406.545 223.786L417.944 235.15L406.123 246.934Z'
}, {
  x: 379.37200927734375,
  y: 103.91699981689453,
  path: 'M414.413 127.065L425.812 138.428L413.991 150.212L402.592 138.849L390.771 150.633L379.372 139.27L414.835 103.917L426.234 115.28L414.413 127.065Z'
}, {
  x: 45.91210174560547,
  y: 242.35299682617188,
  path: 'M53.0351 256.301L45.9121 249.2L52.7807 242.353L74.1497 263.655L67.2811 270.503L60.1581 263.402L53.2895 270.249L46.1665 263.148L53.0351 256.301Z'
}, {
  x: 281.57000732421875,
  y: 423.94500732421875,
  path: 'M288.693 437.893L281.57 430.792L288.438 423.945L309.807 445.248L302.939 452.095L295.816 444.994L288.947 451.841L281.824 444.74L288.693 437.893Z'
}, {
  x: 15.51710033416748,
  y: 282.0480041503906,
  path: 'M30.3561 303.668L23.824 288.327L38.6631 282.048L58.2593 328.07L43.4203 334.349L36.8882 319.009L22.0492 325.288L15.5171 309.947L30.3561 303.668Z'
}, {
  x: 338.6419982910156,
  y: 166.86700439453125,
  path: 'M356.822 180.495L365.661 184.984L360.991 194.122L352.152 189.633L347.481 198.771L338.642 194.281L352.654 166.867L361.493 171.357L356.822 180.495Z'
}, {
  x: 285.1789855957031,
  y: 124.8280029296875,
  path: 'M285.179 170.686L294.121 124.828L340.122 133.742L331.181 179.6L285.179 170.686Z'
}, {
  x: 213.98899841308594,
  y: 162.5570068359375,
  path: 'M222.127 216.675L213.989 170.669L260.14 162.557L268.277 208.563L222.127 216.675Z'
}, {
  x: 223.32699584960938,
  y: 364.9649963378906,
  path: 'M231.465 419.084L223.327 373.077L269.478 364.965L277.615 410.971L231.465 419.084Z'
}, {
  x: 201.52099609375,
  y: 240.2949981689453,
  path: 'M201.521 276.6L231.012 240.295L267.431 269.694L237.939 306L201.521 276.6Z'
}, {
  x: 41.04199981689453,
  y: 94.49320220947266,
  path: 'M48.5536 144.449L41.042 101.981L83.6423 94.4932L91.1539 136.961L48.5536 144.449Z'
}, {
  x: 114.91000366210938,
  y: 208.7949981689453,
  path: 'M114.91 237.543V208.795H143.748V237.543H114.91Z'
}, {
  x: 98.32230377197266,
  y: 311.59600830078125,
  path: 'M98.3223 340.344V311.596H127.161V340.344H98.3223Z'
}, {
  x: 206.2310028076172,
  y: 71.61669921875,
  path: 'M206.231 96.7716V71.6167H231.465V96.7716H206.231Z'
}, {
  x: 178.54200744628906,
  y: 290.38800048828125,
  path: 'M178.542 315.543V290.388H203.775V315.543H178.542Z'
}].map(function (s, index) {
  return _objectSpread({
    id: index,
    color: pickRandom(colors)
  }, s);
});
var MAX_DISTANCE = 460;
var shapeVariants = {
  visible: function visible(_ref) {
    var delay = _ref.delay,
        color = _ref.color,
        index = _ref.index;
    return {
      fill: ['#F6F9FC', color, '#F6F9FC'],
      transition: {
        delay: delay.current[index]
      }
    };
  }
};

var Shape = function Shape(_ref2) {
  var path = _ref2.path,
      props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_framerMotion.motion.path, (0, _extends2["default"])({
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: path,
    fill: "#F6F9FC",
    variants: shapeVariants
  }, props));
};

var RippleContainer = ( /*#__PURE__*/0, _theming.styled)(_framerMotion.motion.svg, process.env.NODE_ENV === "production" ? {
  target: "e1vnjivi0"
} : {
  target: "e1vnjivi0",
  label: "RippleContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "y301de",
  styles: "display:block;width:100%;height:auto"
} : {
  name: "y301de",
  styles: "display:block;width:100%;height:auto",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var PuzzlePieces = function PuzzlePieces() {
  var delays = (0, _react.useRef)(shapes.map(function () {
    return 0;
  }));
  var rippleControls = (0, _framerMotion.useAnimationControls)();

  function sequence(ox, oy) {
    delays.current = shapes.map(function (_ref3) {
      var x = _ref3.x,
          y = _ref3.y;
      var dx = Math.abs(x - ox);
      var dy = Math.abs(y - oy);
      var d = Math.hypot(dx, dy);
      return (0, _framerMotion.transform)(d, [0, MAX_DISTANCE], [0, 1]);
    });
    rippleControls.start('visible');
  }

  (0, _react.useEffect)(function () {
    var originShape = pickRandom(shapes);
    sequence(originShape.x, originShape.y);
  });
  return /*#__PURE__*/_react["default"].createElement(RippleContainer, {
    width: "460",
    height: "460",
    viewBox: "0 0 460 460",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    animate: rippleControls,
    "data-chromatic": "ignore"
  }, shapes.map(function (_ref4, index) {
    var id = _ref4.id,
        x = _ref4.x,
        y = _ref4.y,
        path = _ref4.path,
        color = _ref4.color;
    return /*#__PURE__*/_react["default"].createElement(Shape, {
      key: id,
      path: path,
      onTap: function onTap() {
        sequence(x, y);
      },
      custom: {
        index: index,
        delay: delays,
        color: color
      }
    });
  }));
};

exports.PuzzlePieces = PuzzlePieces;